import type { ComponentType } from 'react';
import type { FormikProps } from 'formik';
import type { WizardTileConfig } from './tileConfig';
import type {
  OfferGenerationWizardFormValues,
  WizardFormValues,
} from '../../../../domain/customerInquiry';

export interface WizardStepProps {
  values: WizardFormValues;
  form: FormikProps<WizardFormValues>;
  submitted: boolean;
  onNext?: (selectedValue?: string) => void | Promise<void>;
  isSolarFacilitySoldOut?: boolean;
  isGreenPowerConsumptionTooSmall?: boolean;
  isGreyPowerConsumptionTooSmall?: boolean;
  [key: string]: unknown;
}

export interface WizardNode {
  // Step components still use mixed prop shapes while migrating.
  componentClass: ComponentType<any> | null;
  fieldName?: keyof OfferGenerationWizardFormValues;
  stepIndicatorLabel?: string;
  noMapNeeded?: boolean;
  skipThisStep?: boolean;
  props: Record<string, unknown>;
  map?: Record<string, number>;
  urlValue?: string;
  nodes?: WizardNode[];
}

export function mapTileConfigIndex(
  prev: Record<string, number>,
  value: WizardTileConfig,
  index: number
): Record<string, number> {
  const p = prev;
  p[value.value] = index;
  return p;
}
